<div
  class="ki-befund"
  [class]="'ki-befund--' + befund().schwere.toLowerCase()"
  role="region"
  data-testid="ki-befund"
  [attr.aria-label]="'ki.qualitaet.befundRegion' | translate: { text: befund().text }"
>
  <div class="ki-befund__kopf">
    <app-ki-mark [size]="14" />
    <span class="ki-befund__schwere" data-testid="ki-befund-schwere">
      {{ 'ki.qualitaet.schwere.' + befund().schwere | translate }}
    </span>
    <span class="ki-befund__text" data-testid="ki-befund-text">
      @if (befund().schrittNr; as nr) {
        <strong>{{ 'ki.qualitaet.schritt' | translate: { nr } }}</strong>
        ·
      }
      {{ befund().text }}
    </span>
  </div>
  @if (mitDiff()) {
    <div class="ki-befund__diff ki-befund__diff--alt">
      <span class="ki-befund__zeichen" aria-hidden="true">−</span>
      <span class="sr-only">{{ 'ki.qualitaet.diffAktuell' | translate }}</span>
      <span class="ki-befund__diff-text">
        <span class="ki-befund__feld">{{ 'ki.qualitaet.feld.' + befund().feld | translate }}:</span>
        <span class="ki-befund__alt">{{ aktuell() || ('ki.qualitaet.leer' | translate) }}</span>
      </span>
    </div>
    <div class="ki-befund__diff ki-befund__diff--neu">
      <span class="ki-befund__zeichen" aria-hidden="true">+</span>
      <span class="sr-only">{{ 'ki.qualitaet.diffVorschlag' | translate }}</span>
      <span class="ki-befund__neu" data-testid="ki-befund-vorschlag">{{ befund().vorschlag }}</span>
    </div>
  } @else if (befund().vorschlag) {
    <div class="ki-befund__vorschlag" data-testid="ki-befund-vorschlag">
      {{ 'ki.qualitaet.vorschlag' | translate: { text: befund().vorschlag } }}
    </div>
  }
  @if (!readOnly()) {
    <div class="ki-befund__fuss">
      @if (mitDiff()) {
        <button type="button" class="ki-befund__uebernehmen" data-testid="ki-verbessern" (click)="uebernehmen.emit()">
          <mat-icon aria-hidden="true">check</mat-icon>
          {{ 'ki.qualitaet.verbessern' | translate }}
        </button>
      }
      <button type="button" class="ki-befund__lassen" data-testid="ki-lassen" (click)="lassen.emit()">
        {{ (mitDiff() ? 'ki.qualitaet.lassen' : 'ki.qualitaet.erledigt') | translate }}
      </button>
    </div>
  }
</div>
